import React from "react";
import AppBar from "@mui/material/AppBar";

const DefaultAppBar = (props) => {
  return <AppBar {...props} position="fixed" color="primary" />;
};

export default DefaultAppBar;
